import * as types from './types';

const fetchMessages = id => ({ type: types.FETCH_MESSAGES, payload: id });
const fetchMessagesSucceeded = data => ({ type: types.FETCH_MESSAGES_SUCCEEDED, payload: data });
const fetchMessagesFailed = error => ({ type: types.FETCH_MESSAGES_FAILED, payload: error });

const changeTabOption = tab => ({ type: types.CHANGE_TAB_OPTION, payload: tab });

const addMessage = message => ({ type: types.ADD_MESSAGE, payload: message });
const addMessageSucceded = message => ({ type: types.ADD_MESSAGE_SUCCEEDED, payload: message });

const setquicklyTranslate = data => ({ type: types.SET_TRANSLATION, payload: data });

const addFile = id => ({ type: types.ADD_FILE, payload: id });
const addFileSuceeded = data => ({ type: types.ADD_FILE_SUCCEEDED, payload: data });
const removeFile = id => ({ type: types.REMOVE_FILE, payload: id });
const resetFileState = data => ({ type: types.RESET_FILES, payload: {} });
const errorUpload = data => ({ type: types.ERROR_UPLOAD, payload: {} });
const showSnackBar = snackBarOptions => ({ type: types.SHOW_SNACKBAR, payload: snackBarOptions });
const hideSnackBar = () => ({ type: types.HIDE_SNACKBAR });
const revertError = () => ({ type: types.REVERT_ERROR });
const showModal = () => ({ type: types.SHOW_MODAL });

export {
  setquicklyTranslate,
  addMessage,
  changeTabOption,
  fetchMessages,
  fetchMessagesSucceeded,
  fetchMessagesFailed,
  addMessageSucceded,
  addFile,
  addFileSuceeded,
  removeFile,
  resetFileState,
  errorUpload,
  showSnackBar,
  hideSnackBar,
  revertError,
  showModal
};
